import React, { Component } from "react";
import { Panel } from "react-bootstrap";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loadable from "react-loading-overlay";
import Moment from "react-moment";
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';
import AuthContext from '../auth-context';
import RelatedPanel from '../Contacts/RelatedPanel';
import Field from '../Shared/Field';
import HistoryPanel from '../Shared/HistoryPanel';
import JSONDebugger from '../utils/JSONDebugger';
import LeadsService from "../utils/LeadsService";
import SeminarsService from "../utils/SeminarsService";
import UsersService from '../utils/UsersService';
import { examBoardForRegion } from '../utils/variables';
import ButtonBar from './ButtonBar';


class Show extends Component {
  static contextType = AuthContext;

  state = {}

  constructor(props) {
    super(props);
    this.state = { isLoading: false, openSeminars: [] };
  }

  componentDidMount() {
    this.loadLead(this.props.match.params.id)
    this.loadOpenSeminars()
    this.fetchPeople()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.id !== this.props.match.params.id) {
      this.loadLead(nextProps.match.params.id)
    }
  }

  loadLead = async (id) => {
    this.setState({ isLoading: true });
    const lead = await LeadsService.get(id)
    this.setState({ isLoading: false, lead: lead })
  }

  loadOpenSeminars = async () => {
    const openSeminars = await SeminarsService.openSeminars()
    this.setState({ openSeminars: openSeminars })
  }

  fetchPeople() {
    UsersService.allUsers().then(data => {
      this.setState({ users: data, loadingInProgress: false })
    });
  }

  handleLeadUpdated = (lead) => {
    this.setState({ lead: lead })
  }

  reloadLead = () => {
    this.loadLead(this.props.match.params.id)
  }

  handleAssignedChange(leadId, event) {
    this.setState({ actionInProgress: true })
    LeadsService.takeAction('assign', leadId, { email: event.target.value }).then((response) => {
      this.handleLeadUpdated(response.lead)
      this.setState({ actionInProgress: false });
      Alert.success(`Assigned to ${response.lead.assigned_to || 'nobody'}`)
    })
  }

  render() {
    const { lead, isLoading, openSeminars } = this.state
    if (!lead) return null

    const authStore = this.context

    const isRestrictedCoach = authStore.hasRole('coach_restricted')
    if (isRestrictedCoach && lead.assigned_to !== authStore.profile.email) return <div>You do not have permission to see this follow up</div>

    return (
      <div>
        <Loadable
          active={isLoading}
          spinner
          text=""
          color="#444"
          background="rgba(255, 255, 255, 0.5)"
        >
          {lead && (
            <div>
              <h3 className="first-title">
                Follow Up #{lead.id} : {lead.email}
                {lead.flags.includes('completed') ? <span className='badge badge-success' style={{ backgroundColor: 'rgb(27, 162, 92)' }}>COMPLETED</span>
                  : <span> - {lead.region} / {examBoardForRegion(lead.region)}</span>
                }
              </h3>
              {lead.due_at && <h4>Due: <Moment format="MMM Do YYYY h:mm a">{lead.due_at}</Moment></h4>}
              <div style={{ marginBottom: 12 }}><ButtonBar lead={lead} openSeminars={openSeminars} handleLeadUpdated={this.handleLeadUpdated} reloadLead={this.reloadLead} /></div>
              <div className='row'>
                <div className='col-md-6'>
                  <Panel bsStyle="success" className='compact-panel'>
                    <Panel.Heading>
                      <Panel.Title componentClass="h3">
                        Info
                      </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>

                      {this.state.users && <select id='assigned' onChange={(event) => this.handleAssignedChange(lead.id, event)} defaultValue={lead.assigned_to}>
                        <option value=''>(not assigned)</option>
                        {this.state.users.map(user => (<option key={user.email} value={user.email}>{user.name}</option>))}
                      </select>}
                      <h5 style={{ marginBottom: 4, paddingBottom: 4, borderBottom: '1px solid #ccc' }}>Initial Notes</h5>
                      <Field value={lead.initial_notes} blockDisplay={true} />

                      <h5 style={{ marginBottom: 4, paddingBottom: 4, borderBottom: '1px solid #ccc' }}>Contact Info</h5>

                      <Field label='Region' value={lead.region} />
                      <Field label='Education' value={<span>{examBoardForRegion(lead.region)}</span>} />

                      <Field label='First Name' value={lead.first_name || '<unknown name>'} />
                      <Field label='Student First Name' value={lead.student_first_name || '<unknown name>'} />
                      <Field label='Email' value={lead.contact ? <Link to={`/m1/contacts/${lead.contact.id}`}>{lead.email}</Link> : lead.email || '<unknown email>'} />
                      <Field label='Mobile' value={lead.mobile} dialer={true} />

                      <h5 style={{ marginBottom: 4, paddingBottom: 4, borderBottom: '1px solid #ccc' }}>Additional Info</h5>
                      <Field label='Booking from' value={lead.booking_from} />
                      <Field label='Business stream' value={lead.business_stream} />
                      <Field label='M1 Booking by' value={lead.m1_booking_user} />
                      <Field label='Created At' value={<Moment format="MMM Do YYYY h:mm a">{lead.created_at}</Moment>} />

                      <h5 style={{ marginBottom: 4, paddingBottom: 4, borderBottom: '1px solid #ccc' }}>UTM</h5>
                      <Field label='UTM Source' value={lead.utm_source} />
                      <Field label='UTM Medium' value={lead.utm_medium} />
                      <Field label='UTM Campaign' value={lead.utm_campaign} />
                      <Field label='UTM Term' value={lead.utm_term} />
                      <Field label='UTM Content' value={lead.utm_content} />

                    </Panel.Body>
                  </Panel>
                </div>
                <div className='col-md-6'>
                  <RelatedPanel deals={lead.related_deals} followUps={lead.related_follow_ups.filter((f) => f.id !== lead.id)} />
                </div>
              </div>

              <h4 style={{ marginTop: 10 }}>Extra Information</h4>

              <Panel bsStyle="success" className='compact-panel'>
                <Panel.Heading>
                  <Panel.Title componentClass="h3">
                    History

                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body style={{ padding: 3 }}>
                  {lead && lead.history ? <HistoryPanel history={lead.history} /> : null}
                </Panel.Body>
              </Panel>

              <JSONDebugger json={this.state} />

            </div>)}
        </Loadable>
      </div>


    )
  }
}

export default Show